export default __webpack_public_path__ + "static/media/fixture2_background.9988c819.jpg";